<script setup>
  import { ref } from "vue";
  import moment from "moment";
  import { storeToRefs } from "pinia";
  import { LoadingOverlay } from "@/components/episto-ui/loading-overlay";
  import { useWeightingsStore } from "@stores/weightings";
  import ListContainer from "@/components/episto-ui/list/ListContainer.vue";
  import ListItem from "@/components/episto-ui/list/ListItem.vue";

  const weightingsStore = useWeightingsStore();
  const { weightings, selectedWeightingIndex, selectedWeighting } = storeToRefs(weightingsStore);
  const { addNewWeighting } = weightingsStore;

  const isDeleting = ref(false);

  const selectWeighting = (index) => {
    selectedWeightingIndex.value = index;
    selectedWeighting.value = weightings.value[index];
  };

  const deleteWeighting = async (index) => {
    isDeleting.value = true;
    await weightingsStore.deleteWeighting(index);
    isDeleting.value = false;
  };

  const isWeightingSelected = (index) => selectedWeightingIndex.value === index;
  const weightingSubtitle = (weighting) => {
    if (weighting.average_weight == null) return "No weights";
    const launchedAt = weighting.launched_at != null ? moment(weighting.launched_at).format("LL") : "Unknown";
    return `Last update: ${launchedAt}`;
  };
</script>

<template>
  <LoadingOverlay
    v-if="isDeleting"
    text="Loading..." />
  <ListContainer
    :add-element="addNewWeighting"
    element-name="weighting"
    :show-header="false">
    <template #elements>
      <ListItem
        v-for="(weighting, index) in weightings"
        :key="weighting.token"
        :index="index"
        :element-title="weighting.name"
        :element-subtitle="weightingSubtitle(weighting)"
        :select-element="selectWeighting"
        :delete-element="deleteWeighting"
        :confirm-deletion="true"
        :is-element-selected="isWeightingSelected" />
    </template>
  </ListContainer>
</template>
